/**
 * GeoManager — Utility Functions
 *
 * Notifications, HTML escape, modals, formatting.
 */

export function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

export function formatNumber(num) {
    if (num === null || num === undefined) return '0';
    return new Intl.NumberFormat('fr-FR').format(num);
}

function createNotificationContainer() {
    const container = document.createElement('div');
    container.id = 'geo-notifications';
    container.className = 'geo-notifications';
    document.body.appendChild(container);
    return container;
}

export function showNotification(message, type = 'info') {
    const container = document.getElementById('geo-notifications') || createNotificationContainer();

    const notification = document.createElement('div');
    notification.className = `geo-notification geo-notification-${type}`;
    notification.innerHTML = `
        <i class="fas ${type === 'success' ? 'fa-check-circle' : type === 'error' ? 'fa-exclamation-circle' : 'fa-info-circle'}"></i>
        <span>${message}</span>
    `;

    container.appendChild(notification);

    setTimeout(() => {
        notification.classList.add('fade-out');
        setTimeout(() => notification.remove(), 300);
    }, 3000);
}

export function createModal(title, content) {
    closeModal();

    const modal = document.createElement('div');
    modal.id = 'geo-modal';
    modal.className = 'geo-modal';
    modal.innerHTML = `
        <div class="geo-modal-backdrop" onclick="GeoManager.closeModal()"></div>
        <div class="geo-modal-content">
            <div class="geo-modal-header">
                <h3>${title}</h3>
                <button class="geo-modal-close" onclick="GeoManager.closeModal()">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="geo-modal-body">
                ${content}
            </div>
        </div>
    `;

    document.body.appendChild(modal);
    setTimeout(() => modal.classList.add('active'), 10);

    return modal;
}

export function closeModal(modalId = 'geo-modal') {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.remove('active');
        setTimeout(() => modal.remove(), 200);
    } else {
        const genericModal = document.getElementById('geo-modal');
        if (genericModal) {
            genericModal.classList.remove('active');
            setTimeout(() => genericModal.remove(), 200);
        }
    }
}
